import RiFileSearchLine from '@ben/icons/file-search-line';
import { ButtonVariant } from '@ben/orion/deprecated-button/button';
import type { RIconComponent } from '@ben/orion/remix-icon';
import { VisuallyHidden } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import EmptyState from '../../../empty-state/empty-state';

export interface TableEmptyStateProps {
  title?: string;
  info?: string;
  icon?: RIconComponent;
  buttonLabel?: string;
  onClickButton?: () => void;
}

export const TableEmptyState = ({
  title,
  info,
  icon,
  buttonLabel,
  onClickButton,
}: TableEmptyStateProps) => {
  const { t } = useTranslation();
  return (
    <EmptyState
      title={title ?? t('table.emptyState.nothingToShow')}
      info={info ?? t('table.emptyState.nothingToShowInfo')}
      icon={icon ?? RiFileSearchLine}
      buttonText={buttonLabel}
      onClick={onClickButton}
      buttonVariant={ButtonVariant.secondary}
    />
  );
};

export const TableNoResults = () => {
  const { t } = useTranslation();
  return (
    <>
      <EmptyState
        title={t('table.emptyState.noResultsFound')}
        info={t('table.emptyState.noResultsFoundInfo')}
        icon={RiFileSearchLine}
      />
      <VisuallyHidden aria-live="assertive">
        {t('phrases.noResultsFound')}
      </VisuallyHidden>
    </>
  );
};
